var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParseForm',{ref:"base",attrs:{"formParams":_vm.formParams,"formId":"formParams.formId","opCode":_vm.opCode,"funcClick":_vm.bindClickEvent,"funcOnChange":_vm.onChangeEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }